import { zonedTimeToUtc } from 'date-fns-tz';
import { TimeRange } from 'store/resource-time-ranges/types';

export function isDateInBetweenInclusive(date: Date, start: Date, end: Date) {
  return date.getTime() >= start.getTime() && date.getTime() <= end.getTime();
}
export function getStartDatetimeFromTimeRange(timeRange: TimeRange, timezone: string): Date {
  return zonedTimeToUtc(`${timeRange.date} ${timeRange.time}:00.000`, timezone);
}
